import { sendTracking } from 'helpers';
import React from 'react';
import { isMobile } from 'react-device-detect';

const AdInfo = ({ profileSrc, advertiser, title, adUrl, clickLogUrl }) => {
    const renderMobileContent = () => (
        <>
            <div className="brand">
                <img src={profileSrc} alt="thumb-img" className="thumb" />
                <strong>{advertiser}</strong>
            </div>
            <p className="title">{title}</p>
            <span className="a_d">AD</span>
        </>
    );

    const renderDesktopContent = () => (
        <>
            <img src={profileSrc} alt="thumb-img" className="thumb" />
            <div className="detail">
                <strong className="brand">{advertiser}</strong>
                <p className="title">{title}</p>
                <span className="a_d">AD</span>
            </div>
        </>
    );

    const handleInfoClick = () => {
        sendTracking(clickLogUrl)
    }

    return (
        <div className="brand-info">
            <a href={adUrl} target="_black" onClick={handleInfoClick}>
                {isMobile ? renderMobileContent() : renderDesktopContent()}
            </a>
        </div>
    );
};

export default AdInfo;